export const AttendanceConstants = {
    DIRECT_TRANSFER_TEAM: 'DIRECT_TRANSFER',
    ORLEANS_DISTRIBUTION: 'Orleans',
    REDIS_DISTRIBUTION: 'Redis',
    DEFAULT_DIRECT_TRANSFER_REQUESTED_NUMBER_OF_AGENTS: 200,
    // Owner configuration
    TRANSFER_DIRECTLY_CONFIG: 'CanTransferDirectly',
    TRANSFER_WITHOUT_AGENTS_CONFIG: 'CanTransferWithoutAgents',
    DISTRIBUTION_TYPE: 'DistributionType',
    CALLS_VOICE_INBOUND_ENABLED: 'CallsVoiceInboundEnabled',
    // Transfer segment bot track
    TEAM_TRANSFER_ENABLED: 'helpdesk-general-settings-transfer-enabled',
    TEAM_TRANSFER_DISABLED: 'helpdesk-general-settings-transfer-disabled',
    DIRECT_TRANSFER_ENABLED: 'helpdesk-general-settings-direct-transfer-enabled',
    //errors
    CREATE_DIRECT_TRANSFER_TEAM_ERROR: 'Error: Cód. 64: Unable to allocate an agent to the direct transfer queue',
    //Send files configuration
    SETTING_TO_SEND_EXTERNAL_FILE_ENABLED: 'helpdesk-general-settings-external-attachment-enabled',
    SETTING_TO_SEND_EXTERNAL_FILE_DISABLED: 'helpdesk-general-settings-external-attachment-disabled',
    //Fake profile
    TRACKING_OPEN_MODAL_FAKE_PROFILE: 'helpdesk-agent-profile-modal-open',
    TRACKING_CLOSE_MODAL_FAKE_PROFILE: 'helpdesk-agent-profile-modal-closed',
    FAKE_SALES_PROFILE: 'SALES',
    FAKE_SUPPORT_PROFILE: 'SUPPORT',
    FAKE_PROFILE_NOT_INFORMED: 'NOTINFORMED',
    //Special char to escape commas on string lists from url
    COMMA_CHAR: ',',
    COMMA_CHAR_ESCAPED: '\u001b,',
    //History phased constants
    PORTAL_ONLY: 'portal-only',
    MFE_ONLY: 'mfe-only',
    BOTH_SCREENS: 'both',
    HISTORY_SCREEN: 'history-screen',
    MFE_SCREEN: 'mfe',
};
